export default __webpack_public_path__ + "static/summer_containers12-01bd918ef027e474d6066f34e71372ce.webp";